<template>
  <div>
  <div class="flex flex-wrap items-center flex-col-reverse md:flex-col">
    
    <div class="w-full mb-3">
      <draggable :list="itemsarray" animation="600" group="small" tag="ul" class="flex flex-row px-4">
        <li v-for="(choice, index) in itemsarray" class="flex-grow mb-0 mx-1 overflow-hidden text-center text-gray-900 bg-white rounded shadow-lg" :key="index">
            <div class="block cursor-move">{{ index + 1 }}</div>
            <span class="block align-middle cursor-move">
              <span class="align-middle text-base">{{ choice.attributes['title'].text }}</span>
            </span>
        </li>
      </draggable>
    </div>
    
    <div class="hrank-wrapper py-3">
      
          <!-- <div class="labels-container hrank-item relative">
                <div class="flex-grow h-full align-middle">
                  <div class="attributes h-full flex flex-col inline-block text-xxs leading-tight text-center">
                      <div class="flex-1 flex flex-col flex-grow even:bg-gray-200 justify-center relative" v-for="(labels, index) in labelsarray" :id="['item'] + index">
                          <span class="label container">{{ labels.label }}</span>
                      </div>
                  </div>
                </div>
              </div> -->
            <draggable :list="itemsarray" animation="300" group="main" tag="ul" class="hrank-responsive" handle=".handle">
              
              <li v-for="(choice, index) in itemsarray" class="hrank-item">
                <div class="handle"></div>
                <!-- <div class="itemnumber flex items-center absolute right-0 top-0 w-6 justify-center bg-gray-200 cursor-move">{{ index + 1 }}</div> -->
                <div class="flex-grow h-full align-middle">
                  <span class="align-middle text-base"></span>
                  <div class="attributes h-full flex flex-col inline-block text-xxs leading-tight text-center" :id="['item'] + index">
                      <div class="cell" v-for="(attributes, index) in choice.attributes">
                          <span class="label container">{{ attributes.label }}</span>
                          <span class="description" v-html="attributes.text"></span>
                      </div>
                  </div>
                </div>
              </li>
            </draggable>
    </div>
  </div>
  <div class="submit-button-wrapper">
        <button id="submitResults" @click="putResults" type="submit" class="px-5 py-2">Next <i aria-hidden="true" class="material-icons align-middle text-3xl">forward</i></button>
    </div>
</div>
</template>

<script>
import VTooltip from 'v-tooltip'
import axios from 'axios'
import draggable from 'vuedraggable'

  export default {
    display: "Simple",
    order: 1,
      components: {
        draggable,
      },
        props: {
            array: '',
            labels: '',
            route:'',
        },
        data() {
          return {
            itemsarray: this.array,
            labelsarray: this.labels,
          }
        },
        methods: {
            putResults: function (event) {
              $( "#submitResults").addClass( "loading" );
              axios.put(this.route, { 
                results: this.array.map(dataSet => dataSet.id) 
              }).then(function (response) {
                  console.log(response);
                }).then(function (event) {
                  location.reload();
                })
            }
              
          }
      
      };
</script>
